module.exports = __webpack_public_path__ + "static/media/mobiles.bac99979.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/mobiles.png
// module id = 287
// module chunks = 0